import pl from '../langs/pl.json';
import de from '../langs/de.json';
import cz from '../langs/cz.json';

const LANGS = { pl, de, cz };
const DEFAULT_LANG = 'pl';

const LANG_ALIASES = {
    pl: 'pl', 'pl-pl': 'pl',
    de: 'de', 'de-de': 'de',
    cz: 'cz', cs: 'cz', 'cs-cz': 'cz',
};

export function normalizeLang(code) {
    if (!code) return null;
    return LANG_ALIASES[String(code).toLowerCase().replace('_', '-')] || null;
}

class LangClass {
    current = DEFAULT_LANG;

    constructor() {
        this.current = this._getInitialLang();
        this._applyToHtml();
    }

    _getInitialLang() {
        const params = new URLSearchParams(window.location.search);
        const normalizedParam = normalizeLang(params.get('lang'));
        if (normalizedParam) return normalizedParam;
        const normalizedHtml = normalizeLang(document.documentElement.lang);
        if (normalizedHtml) return normalizedHtml;
        return DEFAULT_LANG;
    }

    setLang(lang) {
        if (!LANGS[lang]) return;
        this.current = lang;
        this._applyToHtml();
        this._updateUrlParam(lang);
    }

    _applyToHtml() {
        const map = { pl: 'pl', de: 'de', cz: 'cs' };
        document.documentElement.lang = map[this.current] || 'pl';
    }

    _updateUrlParam(lang) {
        const url = new URL(window.location.href);
        url.searchParams.set('lang', lang);
        window.history.replaceState({}, '', url.toString());
    }

    t(key, params) {
        let value = LANGS[this.current]?.[key] ?? LANGS[DEFAULT_LANG]?.[key] ?? key;
        if (params) {
            Object.entries(params).forEach(([name, val]) => {
                value = value.replaceAll(`{${name}}`, String(val));
            });
        }
        return value;
    }
}

const langInstance = new LangClass();

export function _t(key, params) {
    return langInstance.t(key, params);
}

export { langInstance as lang };
